(function () {
  angular
    .module('specsguardApp')
    .factory('LibElement', LibElement);

  LibElement.$inject = ['$resource'];

  function LibElement ($resource) {
    return $resource('/api/element/:id/:controller', {
      id: '@_id'
    }, {
      getAll: {
        method: 'GET', isArray: true
      },
      save: {
        method: 'POST',
      },
      patch: {
        method: 'PATCH',
      },
      addComment: {
        params: {
          controller: 'comment'
        },
        method: 'POST',
        isArray: true
      },
      remove: {
        method: 'DELETE',
        isArray: true
      },
    });
  }
})();
